import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Card';
import { Tooltip } from 'Components/UI/Tooltip';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    width: theme.dimensions.sm,
    height: 85,
    padding: theme.spacing(2),
    cursor: 'pointer',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: theme.palette.facet.lightGray2,
    },
    '&[disabled]': {
      backgroundColor: theme.palette.facet.lightGray2,
    },
  },
  institutionLogo: {
    maxWidth: theme.dimensions.sm - (theme.spacing(4)),
  },
}));

function PreferredInstitutionCard({ resource, onClick }) {
  const classes = useStyles();
  const disabled = !!resource.attr('errorMessage');
  return (
    <Tooltip placement="bottom" title={disabled ? resource.attr('errorMessage') : ''} zIndex={1400}> {/* zIndex of 1400 beats modals/dialogs */}
      <Card
        test={`inst-${resource.id()}`}
        className={classes.root}
        onClick={e => (disabled ? null : onClick(resource, e))}
        style={{
          color: resource.attr('color'),
        }}
        disabled={disabled}
      >
        <img src={resource.attr('logo')} className={classes.institutionLogo} />
      </Card>
    </Tooltip>
  );
}

PreferredInstitutionCard.defaultProps = {
  onClick: () => {
  },
};

PreferredInstitutionCard.propTypes = {
  resource: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default PreferredInstitutionCard;
